import { render, staticRenderFns } from "./MediaViewPage.vue?vue&type=template&id=0d1c800d&scoped=true&"
import script from "./MediaViewPage.vue?vue&type=script&lang=js&"
export * from "./MediaViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c800d",
  null
  
)

export default component.exports